import * as React from "react";
import ReactDOM from "react-dom";
import { hostnameToStorefront, storefrontIsStore } from "@glamcorner/core-cf-lib/lib/client";
import "./storefront-indicator.scss";

const storefrontNameMap = {
  "myer-bourke.store": "MYER Bourke",
  "myer-pitt.store": "MYER Pitt",
};

interface StorefrontIndicatorProps {
  storefront: string;
}

export const StorefrontIndicator: React.SFC<StorefrontIndicatorProps> = (props) => {
  const name = storefrontNameMap[props.storefront] || props.storefront;

  return <div className="c-storefront-indicator">{name}</div>;
};

export function installStorefrontIndicatorToBody() {
  if (document.body) {
    if (storefrontIsStore()) {
      const storefront = hostnameToStorefront();
      const storefrontIndicatorElement = document.createElement("div");

      document.body.appendChild(storefrontIndicatorElement);
      ReactDOM.render(<StorefrontIndicator storefront={storefront} />, storefrontIndicatorElement);
    }
  }
}
